var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"caption"},[_vm._v(" Round started "),_c('br'),_vm._v(" "+_vm._s(this.displayString)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }